import { NSARouterMakerResult } from "namirasoft-account-react";
import { FilterItem } from "namirasoft-core";
import { NamirasoftERPMetaDatabase, OdometerInputRow, OdometerRow, OdometerUnit, VehicleRow } from "namirasoft-erp";
import { NSBox, NSBoxDateTime, NSBoxEntity, NSBoxEnum, NSBoxInteger, NSBoxTextArea, NSColumn, NSRow } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScope, ErpScopeField, ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { isEdit: boolean; }

export default class OdometerEditPage extends Component<Props>
{
    Vehicle = createRef<NSBoxEntity<VehicleRow>>();
    Date = createRef<NSBoxDateTime>();
    Value = createRef<NSBoxInteger>();
    Unit = createRef<NSBoxEnum<OdometerUnit>>();
    Description = createRef<NSBoxTextArea>();

    override render()
    {
        let db = new NamirasoftERPMetaDatabase(this.props.account.token_manager, console.error);

        return (
            <ErpLayout<OdometerRow, OdometerInputRow>
                {...this.props}
                mode={ErpScopeMode.Select}
                fields={[ErpScopeField.Company, ErpScopeField.Branch]}
                pages={{
                    entity: ErpEntities.odometer(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): OdometerInputRow => ({
                                        company_id: ErpScope.getCompanyId() ?? "",
                                        branch_id: ErpScope.getBranchId() ?? "",
                                        vehicle_id: this.Vehicle.current?.getValueOne() ?? "",
                                        date: new Date(this.Date.current?.getValue() ?? new Date().toISOString()),
                                        value: this.Value.current?.getValue() ?? 0,
                                        unit: this.Unit.current?.getValueEnumOne(OdometerUnit, OdometerUnit.KM) ?? OdometerUnit.KM,
                                        description: this.Description.current?.getValue() ?? null,
                                        odometer_category: [],
                                        odometer_tag: [],
                                        odometer_field: [],
                                    }),
                                    setRow: (row: OdometerRow) =>
                                    {
                                        ErpScope.set({ company_id: row.company_id, branch_id: row.branch_id });
                                        this.Vehicle.current?.setValueOne(row.vehicle_id);
                                        this.Date.current?.setValue(new Date(row.date).toISOString());
                                        this.Value.current?.setValue(row.value);
                                        this.Unit.current?.setValueOne(row.unit);
                                        this.Description.current?.setValue(row.description);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxEntity<VehicleRow>
                        ref={this.Vehicle} title="Vehicle" info={{ link: "https://namirasoft.com/erp/console-guide/odometer/#field-vehicle-id" }} required multiple={false}
                        table_name="vehicle" table={db.tables.vehicle}
                        list={(filters, page, size, sorts) =>
                        {
                            let f: FilterItem[] = filters ? [...filters] : [];
                            f = ErpScope.pushFilter(f, db.tables.vehicle, "company_id", ErpScope.getCompanyId());
                            f = ErpScope.pushFilter(f, db.tables.vehicle, "branch_id", ErpScope.getBranchId());
                            return this.props.servers.erp.vehicle.List(f, page, size, sorts, null);
                        }}
                        getValue={(item) => item.id} getTitle={(item) => item.name} getSort={() => null}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxDateTime ref={this.Date} required defaultValue={this.props.isEdit ? undefined : new Date()} title="Date" info={{ link: "https://namirasoft.com/erp/console-guide/odometer/#field-date" }} style={{ width: NSBox.width.double }} />
                    <NSRow style={{ gap: 8 }}>
                        <NSBoxInteger ref={this.Value} required title="Value" info={{ link: "https://namirasoft.com/erp/console-guide/odometer/#field-value" }} style={{ width: NSBox.width.one }} />
                        <NSBoxEnum<OdometerUnit>
                            ref={this.Unit} title="Unit" info={{ link: "https://namirasoft.com/erp/console-guide/odometer/#field-unit" }} required multiple={false}
                            getEnumObject={() => OdometerUnit}
                            style={{ width: NSBox.width.one }}
                        />
                    </NSRow>
                    <NSBoxTextArea ref={this.Description} required={false} title="Description" info={{ link: "https://namirasoft.com/erp/console-guide/odometer/#field-description" }} style={{ width: NSBox.width.double }} />
                </NSColumn>
            </ErpLayout>
        );
    }
}